<dx-toolbar class="panel-toolbar" (onContentReady)="onContentReady($event)">
  <!-- Tam ekran: her sekmenin ilk başlığında (TamEkranService).
       Öğe hep yerinde kalır, yalnız içi *ngIf'li: dxi-item'ı *ngIf ile sonradan eklemek DevExtreme araç çubuğunu
       baştan çizdiriyor ve diğer öğelerdeki dx-button'ların içi boşalıyordu (Tahsilat Girişi işlem düğmeleri).
       span sabit kalmalı: içinde yalnız *ngIf olan dxi-item'ı DevExtreme boş öğe sayıp sonradan gelen içeriği göstermiyor. -->
  <dxi-item location="before" locateInMenu="never">
    <span class="tam-ekran-yeri"><ng-container *ngIf="(tamEkran.sahipler$ | async)?.has(el.nativeElement)"><dk-tam-ekran-dugmesi></dk-tam-ekran-dugmesi><dk-yardim-dugmesi></dk-yardim-dugmesi></ng-container></span>
  </dxi-item>
  <dxi-item location="before" locateInMenu="never">
    <span class="form-name">{{formName}}</span>
  </dxi-item>
  <dxi-item location="center" locateInMenu="never">
    <span class="info">{{customInfo}}</span>
  </dxi-item>

  <!--
    Ekrana ozel buton alani (ic icerik projeksiyonu).
    dynamicButtons yerine bunu kullanin: oradaki dxi-item locateInMenu="auto"
    oldugu icin butonlar dar ekranda "..." menusune dusuyor. Buradaki
    locateInMenu="never" - butonlar her zaman yan yana kalir.
    Kullanim: <dk-form-header>...<div class="afterCustom"> ... </div></dk-form-header>
  -->
  <dxi-item location="after" locateInMenu="never">
    <ng-content select=".afterCustom"></ng-content>
  </dxi-item>

  <ng-container *ngIf="dynamicButtons">
    <dxi-item location="after" locateInMenu="auto" *ngFor="let dynamicButton of dynamicButtons; trackBy: trackByFn">
      <div class="dynamic-button-container">
        <ng-container >
          <dx-button
          [style]="dynamicButton?.style"
          [disabled]="((dynamicButton?.disabled ) || (dynamicButton?.donemKontrolYn ? (!donemAktif ) : false))&& (this.makeThisButtonActive !== dynamicButton.name)"
          [text]="dynamicButton?.text"
          [icon]="dynamicButton.icon"
          [type]="dynamicButton.type"
          [hint]="dynamicButton.hint"
          [width]="dynamicButton.width ? dynamicButton.width : 'auto'"
          [stylingMode]="dynamicButton.stylingMode"
          (click)="handleDynamicButtonClick(dynamicButton)"
          ></dx-button>
        </ng-container>
      </div>
    </dxi-item>
  </ng-container>

  <dxi-item location="after" locateInMenu="never">

    <ng-container *ngIf="formActions">
      <dx-drop-down-button
        text="İşlemler"
        stylingMode="contained"
        displayExpr="name"
        keyExpr="value"
        [dropDownOptions]="{ width:150 }"
        [items]="formActions"
        (onItemClick)="onActionsItemClick($event)"
      ></dx-drop-down-button>
    </ng-container>
  </dxi-item>

  <dxi-item location="after" locateInMenu="never">
    <div *dxTemplate>

    <section class="form-header-buttons">


      <ng-container [ngSwitch]="editMode" *ngIf="!removeSaveButton">
        <ng-container *ngSwitchCase="false">
          <ng-container *ngIf="state === 'New'">
            <dx-button stylingMode="contained" type="default" text="{{saveButtonTitle || 'Kaydet'}}" [disabled]="isLoading || !formYetkiler?.insertYn"
                       (onClick)="handleSaveClick()"></dx-button>
            <dx-button *ngIf="saveAndContinue" stylingMode="contained" type="normal" text="{{'Kaydet&Devam'}}" [disabled]="isLoading || !formYetkiler?.insertYn"
                       (onClick)="handleSaveAndContinueClick()"></dx-button>
          </ng-container>
          <dx-button [disabled]="!formYetkiler?.updateYn" *ngIf="state === 'Edit' && !removeEditButton" stylingMode="contained" type="default"
                     text="{{editButtonTitle ||'Düzenle'}}" (onClick)="handleEditClick()"></dx-button>
          <dx-button [disabled]="!formYetkiler?.updateYn" *ngIf="state === 'Turet' && !removeEditButton" stylingMode="contained" type="default"
                     text="{{editButtonTitle ||'Düzenle'}}" (onClick)="handleTuretClick()"></dx-button>
          <ng-container *ngIf="closeButton">
            <dx-button *ngIf="!removeSaveNearCancel" stylingMode="contained" type="danger" [text]="newCancelOrCLoseBtn" (onClick)="onCloseClick()" icon="close"></dx-button>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="true">
          <dx-button *ngIf="!removeSaveNearCancel" stylingMode="contained" type="default" text="{{saveButtonTitle || 'Kaydet'}}" [disabled]="isLoading || !formYetkiler?.updateYn"
                     (onClick)="handleSaveClick()"></dx-button>
          <dx-button stylingMode="contained" type="default" text="İptal"
                     (onClick)="handleCancelClick()"></dx-button>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="removeSaveButton">
        <dx-button stylingMode="contained" type="danger" text="Kapat" (onClick)="onCloseClick()" icon="close"
        ></dx-button>
      </ng-container>
    </section>
  </div>
  </dxi-item>
  <ng-container *ngIf="widthChange">
    <dxi-item location="after" locateInMenu="never">
      <dx-button stylingMode="outlined" type="default" icon="fullscreen"
                 (onClick)="handleWidthClick()"></dx-button>
    </dxi-item>
  </ng-container>

</dx-toolbar>
